import {
  NOTIFICATIONS_FETCH_REQUEST,
  NOTIFICATIONS_FETCH_SUCCESS,
  NOTIFICATIONS_FETCH_FAIL,
  NOTIFICATIONS_MARK_READ,
  NOTIFICATIONS_MARK_ALL_READ,
  NOTIFICATIONS_DELETE,
  NOTIFICATIONS_CREATE,
} from '../constant';

const initialState = {
  notifications: [], // current user notifications ("mine")
  allNotifications: [], // system-wide list (admins only)
  loading: false,
  error: null,
  updating: false,
  creating: false,
};

export const NotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATIONS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case NOTIFICATIONS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        notifications: action.payload.notifications || [],
        allNotifications: action.payload.allNotifications || [],
      };
    case NOTIFICATIONS_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        notifications: [],
        allNotifications: [],
      };
    case NOTIFICATIONS_MARK_READ: {
      const id = action.payload;
      return {
        ...state,
        notifications: state.notifications.map((n) =>
          n._id === id ? { ...n, read: true } : n
        ),
        allNotifications: state.allNotifications.map((n) =>
          n._id === id ? { ...n, read: true } : n
        ),
      };
    }
    case NOTIFICATIONS_MARK_ALL_READ:
      return {
        ...state,
        notifications: state.notifications.map((n) => ({ ...n, read: true })),
        allNotifications: state.allNotifications.map((n) => ({
          ...n,
          read: true,
        })),
      };
    case NOTIFICATIONS_DELETE: {
      const id = action.payload;
      return {
        ...state,
        notifications: state.notifications.filter((n) => n._id !== id),
        allNotifications: state.allNotifications.filter((n) => n._id !== id),
      };
    }
    case NOTIFICATIONS_CREATE: {
      const notification = action.payload;
      return {
        ...state,
        notifications: [notification, ...state.notifications],
        allNotifications: [notification, ...state.allNotifications],
      };
    }
    default:
      return state;
  }
};
